(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[495],{

/***/ 76276:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/register",
      function () {
        return __webpack_require__(91499);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 91499:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);





var RegistrationFlowNew = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(2491), __webpack_require__.e(5675), __webpack_require__.e(1399), __webpack_require__.e(4872), __webpack_require__.e(807), __webpack_require__.e(9803), __webpack_require__.e(8966), __webpack_require__.e(3496), __webpack_require__.e(2298), __webpack_require__.e(4485), __webpack_require__.e(3437), __webpack_require__.e(9486), __webpack_require__.e(5651), __webpack_require__.e(7243), __webpack_require__.e(3361), __webpack_require__.e(3596)]).then(__webpack_require__.bind(__webpack_require__, 99649));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(99649)
            ];
        }
    }
});
var RegistrationFlowOld = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(2491), __webpack_require__.e(5675), __webpack_require__.e(1399), __webpack_require__.e(807), __webpack_require__.e(9803), __webpack_require__.e(2283), __webpack_require__.e(8966), __webpack_require__.e(2298), __webpack_require__.e(4485), __webpack_require__.e(4873), __webpack_require__.e(9486), __webpack_require__.e(5767), __webpack_require__.e(7243), __webpack_require__.e(3361), __webpack_require__.e(5545), __webpack_require__.e(2814)]).then(__webpack_require__.bind(__webpack_require__, 45565));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(45565)
            ];
        }
    }
});
var Register = function(_param) {
    var isNewRegistrationFlowEnabled = _param.isNewRegistrationFlowEnabled, isNewRegistrationSpecialityScreenRemoved = _param.isNewRegistrationSpecialityScreenRemoved, isNomanEasterEggEnabled = _param.isNomanEasterEggEnabled, registrationFlowProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "isNewRegistrationFlowEnabled",
        "isNewRegistrationSpecialityScreenRemoved",
        "isNomanEasterEggEnabled"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: isNewRegistrationFlowEnabled ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(RegistrationFlowNew, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
            specialityScreenRemoved: isNewRegistrationSpecialityScreenRemoved
        }, registrationFlowProps)) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(RegistrationFlowOld, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
            isNomanEasterEggEnabled: isNomanEasterEggEnabled
        }, registrationFlowProps))
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (Register);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(76276); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);